// extracted by mini-css-extract-plugin
export default {"districtMap":"DistrictMap_districtMap__oDKCM"};